import { render, staticRenderFns } from "./CalendarCard.vue?vue&type=template&id=10b775e0&scoped=true&"
import script from "./CalendarCard.vue?vue&type=script&lang=js&"
export * from "./CalendarCard.vue?vue&type=script&lang=js&"
import style0 from "./CalendarCard.vue?vue&type=style&index=0&id=10b775e0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b775e0",
  null
  
)

export default component.exports